import { RootState } from "app/store";

export const selectUid = (state: RootState): string | undefined => {
  return state.user.uid;
};

export const selectUsername = (state: RootState, uid: string | undefined) => {
  if (!uid) {
    return undefined;
  }

  return state.users.usernames[uid];
};

export const selectUsernames = (state: RootState, uids: string[]) => {
  const usernames = new Map<string, string | undefined>();
  uids.forEach((uid) => usernames.set(uid, state.users.usernames[uid]));
  return usernames;
};

export const selectGroups = (state: RootState) => {
  if (!state.user.uid) {
    return undefined;
  }

  return state.user.groups;
};

export const selectUsernamesToFetch = (state: RootState, uids: string[]) => {
  const fetchedUsernames = Object.keys(state.users.usernames);
  const fetchingUsernames = state.users.usernamesBeingFetched;
  return uids.filter(
    (uid) => !fetchedUsernames.includes(uid) && !fetchingUsernames.includes(uid)
  );
};

export const selectAllUsernamesFetched = (state: RootState, uids: string[]) => {
  const fetchedUsernames = Object.keys(state.users.usernames);
  return uids.every((uid) => fetchedUsernames.includes(uid));
};
